<template lang="pug">
div(style="margin-top: -24px;margin-left: -15px;margin-right: -15px;")
  #Categoria
    v-layout(align-start='', justify-start='', row='', fill-height='')
      v-flex(xs12, md12, sm12)
        v-card(color='', style="border-radius:5px;background-color: white;")
            v-card-title(style='padding: 8px !important;').justify-center
              img(src='../assets/logo.png', style='height: 80px;width: auto;')
        v-card(color='', style="border-radius:5px;background-color: black")
            v-card-title(style="padding: 7px;").justify-center
                span.white--text  Administración de Notificaciones
    v-dialog(v-model='dialog', persistent max-width='700px')
          v-btn.mb-2(v-if='cre' slot='activator', style="border-radius:5px;background-color:#0093dd;") Nueva notificación
          v-container(style='background-color:white !important;max-width: 700px;')
            v-card-title.justify-center
                span.headline Notificación
            div
                v-flex(xs12, sm12, md12)
                    v-layout(align-start='', justify-center='', row='', wrap fill-height='')
                        v-flex(xs8)
                          v-form(enctype="multipart/form-data")
                            v-autocomplete(outline
                                :items="clientes"
                                multiple
                                v-model="form.cliente"
                                prepend-inner-icon="chevron_right",
                                required
                                style="width: 95%;margin: 0px 32px 10px;"
                                label="Seleccione los clientes:")

                            div
                              v-checkbox(v-model='selectAll' label='Seleccionar todos' style='padding-left: 30px;')

                            v-text-field(outline
                                required
                                v-model="form.asunto"
                                prepend-inner-icon="person"
                                label="Asunto:"
                                style="height: 56px;width: 95%;margin: 0px 32px 10px;")

                            v-textarea(outline
                                required
                                v-model="form.mensaje"
                                prepend-inner-icon="person"
                                label="Mensaje:"
                                style="width: 95%;margin: 0px 32px 10px;")

                            div
                              v-flex(v-if="loading === true", xs12 sm12 md12)
                                v-layout(align-start='', justify-center='', row='', wrap fill-height='')
                                  v-progress-circular(indeterminate='', color='primary')
                              v-flex(v-if="loading === false", xs12 sm12 md12)
                                v-layout(align-start='', justify-center='', row='', wrap fill-height='')
                                    v-btn(style="background:#0093dd;border-radius:10px;", @click.native='enviar') Enviar
                                    v-btn(style="background:black;border-radius:10px;", @click.native='close') Salir
    v-flex(xs12)
      v-card(flat='')
        v-flex(xs12)
          div(style="margin-top:20px")
            v-flex(xs12)
              v-layout(wrap)
                v-flex(xs6 style='padding-right: 80px;')
                  v-text-field(v-model='search2', append-icon='search', label='Buscar' style='width:100%;')
                v-flex(xs6 style='padding-left: 80px;display: flex;align-items: center;')
                    v-menu(ref='menu1' v-model='modal' :close-on-content-click='false' transition='scale-transition' offset-y='' max-width='450px' min-width='450px')
                        template(v-slot:activator='{ on, attrs }')
                            v-text-field(v-model='dateFormatted' label='Fecha' style='padding-left: 15px;' persistent-hint='' v-bind='attrs' v-on='on')
                        v-date-picker(v-model='date' no-title='' dark='')
                            v-spacer
                            v-btn(text='' color='primary' @click='$refs.menu1.save(date)')
                                | OK
                    v-btn.mx-0(icon, @click='buscar()', style='background: white;border-radius: 100%;margin-left:10px !important;').elevation-4
                        v-icon(color='#ff6500' style='font-size: 1.70rem;') search
          v-layout(align-start='', justify-start='', row='', fill-height='')
            v-flex(xs12 style='margin-top: 5px;')
              v-card(color='', style="border-radius: 0px 0px 20px 20px;background-color:black;")
                  v-card-title(style="padding: 7px;margin-top: 0px;").justify-center
                      span.white--text Lista de Notificaciones
              v-data-table.elevation-1(:headers='headers', :items="notificaciones", :search='search2', style="margin-top: 5px;")
                template(slot='items', slot-scope='props')
                  td {{ props.item.fecha | moment('DD/MM/YYYY') }}
                  td(v-if='props.item.cliente') {{ props.item.cliente.length }}
                  td(v-else) - -
                  td {{ props.item.asunto }}
                  td.justify-start.layout.px-0
                    v-btn.mx-0(icon, style='margin-top: -7px;' @click='abrir(props.item)')
                      v-icon(color='teal') visibility
    //===========================================================Modal Espera==============================================================================================
    v-dialog(v-model='dialog4', persistent max-width='400px' style='background:#f1f2f1')
      v-container(style='max-width: 400px;background:#f1f2f1')
        div(style="margin-top: 20px;")
            v-flex(xs12 sm12)
              v-layout(align-start='', justify-center='', row='', wrap fill-height='')
                v-flex(xs12)
                  v-card-title(style="padding: 7px;").justify-center
                    h4.black--text  Esperando Respuesta del Servidor.!!
                v-flex(xs12)
                    div(style='display: flex;justify-content: center;').text-xs-center
                      img(src='../assets/waiting.gif', with='200' ,height='150')
                v-flex(xs12)
                  v-card-title(style="padding: 7px;").justify-center
                    h5.black--text  Por favor espere...
</template>

<script>
import Api from "@/services/methods";
export default {
  name: "mNotificaciones",
  components: {},
  data: vm => ({
    search2: "",
    info: null,
    dialog: false,
    dialog4: false,
    loading: false,
    selectAll: false,
    modal: false,
    date: new Date().toISOString().substr(0, 10),
    dateFormatted: vm.formatDate(new Date().toISOString().substr(0, 10)),
    notificaciones: [],
    clientes: [],
    form: {
        cliente: [],
        usuario: "",
        asunto: "",
        mensaje: ""
    },
    defaultForm: {
        cliente: [],
        usuario: "",
        asunto: "",
        mensaje: ""
    },
    headers: [
      { text: "Fecha", value: "fecha" },
      { text: "Clientes", value: "cliente" },
      { text: "Asunto", value: "asunto" },
      { text: "Acciones" },
    ],
    cre: "",
    mod: "",
    elm: ""
  }),
  computed: {
    computedDateFormatted () {
      return this.formatDate(this.date)
    }
  },
  watch: {
    selectAll(val) {
      if (val) {
        this.form.cliente = []
        this.clientes.forEach(el=> {
          this.form.cliente.push(el.value)
        })
      } else {
        this.form.cliente = []
      }
    },
    date () {
      this.dateFormatted = this.formatDate(this.date)
    },
  },
  created() {
    this.verificacion();
    this.initialize();
  },
  methods: {
    verificacion() {
      for (let i = 0; i < this.$store.state.webamairca.permisos.length; i++) {
        if (this.$store.state.webamairca.permisos[i].ruta === "Notificaciones") {
          for (
            let j = 0;
            j < this.$store.state.webamairca.permisos[i].accion.length;
            j++
          ) {
            if (
              this.$store.state.webamairca.permisos[i].accion[j] === "Crear"
            ) {
              this.cre = "yes";
            }
            if (
              this.$store.state.webamairca.permisos[i].accion[j] ===
              "Modificar"
            ) {
              this.mod = "yes";
            }
            if (
              this.$store.state.webamairca.permisos[i].accion[j] === "Eliminar"
            ) {
              this.elm = "yes";
            }
          }
        }
      }
    },
    formatDate (date) {
      if (!date) return null
      const [year, month, day] = date.split('-')
      return `${day}/${month}/${year}`
    },
    parseDate (date) {
      if (!date) return null
      const [day, month, year] = date.split('/')
      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
    },
    close() {
        this.info = null
        this.dialog = false
    },
    abrir(item) {
        this.info = item
        this.dialog = true
    },
    enviar() {
        this.form.usuario = this.$store.state.webamairca._id
        if (this.form.cliente && this.form.asunto && this.form.mensaje) {
          this.loading = true
          Api.post("notificaciones", this.form)
            .then(() => {
              this.form = Object.assign({}, this.defaultForm);
              this.dialog = false;
              this.$swal.fire(
                "Felicidades.!",
                "Notificación enviada exitosamente.",
                "success"
              );
              this.loading = false;
              this.initialize();
            })
            .catch(err => {
              console.log(err);
              this.loading = false;
              this.$swal.fire(
                "Oops...",
                "Error encontrado, verifique los datos o llame al administrador.",
                "error"
              );
            });
        }
    },
    initialize() {
      this.dialog4 = true
      Api.get("notificaciones/admin?fecha="+this.date).then(res => {
        this.notificaciones = res.data;
        this.dialog4 = false
      })
      .catch(err=> {
        console.log(err)
        this.dialog4 = false
      })
      Api.get("cliente/email").then(res => {
        this.clientes = []
        if (res.data && res.data.length > 0) {
            res.data.forEach(el=>{
                this.clientes.push({
                    value: el._id,
                    text: el.cli_des
                })
            })
        }
      });
    }
  }
};
</script>
<style lang="scss">
@import "~@/assets/scss/categoria.scss";
</style>
